import { Button, Stack, Typography } from '@mui/material';

import ChevronLeftIcon from 'modules/common/components/Icons/ChevronLeftIcon';
import ChevronRightIcon from 'modules/common/components/Icons/ChevronRightIcon';

export interface InvoicePageHeaderProps {
    title: string;
    onBack: () => void;
    /** The right-hand "next step" button; omitted on read-only pages. */
    next?: { label: string; onClick: () => void; disabled?: boolean };
}

export default function InvoicePageHeader({ title, onBack, next }: Readonly<InvoicePageHeaderProps>) {
    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ px: { xs: 2, md: 4 }, py: 2, bgcolor: 'cement.50', borderBottom: 1, borderColor: 'divider' }}>
            <Button variant="text" color="inherit" startIcon={<ChevronLeftIcon fontSize="small" />} onClick={onBack}>
                Back
            </Button>
            <Typography variant="h5">{title}</Typography>
            {next ? (
                <Button
                    variant="text"
                    color="inherit"
                    endIcon={<ChevronRightIcon fontSize="small" />}
                    disabled={next.disabled}
                    onClick={next.onClick}>
                    {next.label}
                </Button>
            ) : (
                // Keeps the title centred when there is no next step.
                <div style={{ width: 80 }} />
            )}
        </Stack>
    );
}
